import { Component } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export interface FaqTile {
  header: string;
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
  faqTiles: FaqTile[];

  constructor(private transloco: TranslocoService) {
    this.faqTiles = [
      {
        header: this.transloco.translate('faq.tile.1.header'),
        question: this.transloco.translate('faq.tile.1.question'),
        answer: this.transloco.translate('faq.tile.1.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.2.header'),
        question: this.transloco.translate('faq.tile.2.question'),
        answer: this.transloco.translate('faq.tile.2.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.3.header'),
        question: this.transloco.translate('faq.tile.3.question'),
        answer: this.transloco.translate('faq.tile.3.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.4.header'),
        question: this.transloco.translate('faq.tile.4.question'),
        answer: this.transloco.translate('faq.tile.4.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.5.header'),
        question: this.transloco.translate('faq.tile.5.question'),
        answer: this.transloco.translate('faq.tile.5.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.6.header'),
        question: this.transloco.translate('faq.tile.6.question'),
        answer: this.transloco.translate('faq.tile.6.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.7.header'),
        question: this.transloco.translate('faq.tile.7.question'),
        answer: this.transloco.translate('faq.tile.7.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.8.header'),
        question: this.transloco.translate('faq.tile.8.question'),
        answer: this.transloco.translate('faq.tile.8.answer'),
      },
      {
        header: this.transloco.translate('faq.tile.9.header'),
        question: this.transloco.translate('faq.tile.9.question'),
        answer: this.transloco.translate('faq.tile.9.answer'),
      },
    ];
  }
}
